import axios, { AxiosResponse } from 'axios'
import { message } from 'ant-design-vue'
import { ACCESS_TOKEN, USER_INFO } from '@/store/mutation-types'
import { baseURL } from '@/utils/util'
import ls from '@/utils/Storage'
import { globalLoading } from '@/store/reactiveState'
import emitter from '@/utils/eventBus'

const ContentType = {
  urlencoded: 'application/x-www-form-urlencoded;charset=UTF-8',
  json: 'application/json',
  formData: 'multipart/form-data'
}

// 创建 axios 实例   withCredentials: true,
const baseService = axios.create({
  baseURL,
  timeout: 60000,
  responseType: 'json',
  headers: {
    // 显式移除 x-requested-with 头
    'X-Requested-With': undefined
  }
})

// request interceptor
baseService.interceptors.request.use(
  (config) => {
    globalLoading.value = true
    const token = ls.get(ACCESS_TOKEN)
    const userinfo = ls.get(USER_INFO)
    
    // 添加认证相关头
    if (token) {
      // config.headers['token'] = token
      config.headers['Authorization'] = `Bearer ${token}`; // 符合标准鉴权格式      
    }
    if (userinfo) {
      config.headers['username'] = userinfo.username
    }
    
    // 关键：仅在非 FormData 时设置 Content-Type
    if (!(config.data instanceof FormData)) {
      config.headers['Content-Type'] = ContentType.json;
    }
    // 确保移除 x-requested-with 头（与之前的配置呼应）
    delete config.headers['X-Requested-With'];
    
    return config
  },
  (error) => {
    globalLoading.value = false
    return Promise.reject(error)
  }
)


baseService.interceptors.response.use(
  (res: AxiosResponse<any>) => {
    globalLoading.value = false
    if (res.status === 200) {
      return res.data
    }
    return res
  },
  (error) => {
    console.log(error)
    globalLoading.value = false
    const msg = error.message
    const result = error.response
    if (result) {
      const { data, status } = result
      if (data.message) {
        message.error(data.message)
      } else if (status === 401 || status === 403) {
        message.error('登录过期或权限不足, 请重新登陆!')
      } else if (status === 500) {
        message.error('请求数据失败, 请重试!')
      } else if (status === 406) {
        message.error('登陆超时请重新登录!')
        emitter.emit('axios_goto_login')
      }
    } else if (msg) {
      if (msg === 'Network Error') {
        message.error('网络错误,请检查网络!')
      } else {
        message.error(msg)
      }
    } else if (error.__CANCEL__) {
      // ignore message error
    } else {
      message.error('未知错误,请重试!')
    }
    return false
  }
)

export default baseService
